import { render, staticRenderFns } from "./PendingBatchManagement.vue?vue&type=template&id=7003f987&scoped=true"
import script from "./PendingBatchManagement.vue?vue&type=script&lang=js"
export * from "./PendingBatchManagement.vue?vue&type=script&lang=js"
import style0 from "./PendingBatchManagement.vue?vue&type=style&index=0&id=7003f987&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7003f987",
  null
  
)

export default component.exports